import { gql } from '@apollo/client'

export const GET_VIEWERS_ACTIVE_TICKET_ALERTS = gql`
  query getViewersActiveTicketAlerts {
    viewer {
      id
      activeTicketAlerts {
        event {
          id
        }
        eventType {
          id
        }
      }
    }
  }
`
